module.exports = __webpack_public_path__ + "img/tune-component.6677246c.svg";